import {
	type FilterValue,
	filterValuesAtom,
} from '@pages/VendorsSearch/containers/FilterPills/atoms';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';
import { flushVendorImpressions } from '../helpers/trackVendorImpression';

/**
 * Hook that flushes vendor impressions when filters change
 * Should be used at the search page level to ensure impressions are sent
 * before new filtered results load
 */
export function useFlushImpressionsOnFilterChange(): void {
	const filterValues = useAtomValue(filterValuesAtom);

	// Track previous filters to detect changes
	const previousFilterValuesRef = useRef<FilterValue[] | null>(null);

	useEffect(() => {
		// Skip flush on initial mount
		if (previousFilterValuesRef.current === null) {
			previousFilterValuesRef.current = filterValues;
			return;
		}

		// Check if filters have changed by comparing the serialized values
		// This works for all filter types including pricing (min/max) and facets
		const previousSerialized = JSON.stringify(previousFilterValuesRef.current);
		const currentSerialized = JSON.stringify(filterValues);

		// Filters have changed - flush any pending impressions
		if (previousSerialized !== currentSerialized) {
			flushVendorImpressions();
			previousFilterValuesRef.current = filterValues;
		}
	}, [filterValues]);
}
